var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3307_18716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3307_18716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10.25V3.75C9.25 3.5375 9.32145 3.35937 9.46435 3.21562C9.60727 3.07187 9.78435 3 9.9956 3C10.2069 3 10.3854 3.07187 10.5312 3.21562C10.6771 3.35937 10.75 3.5375 10.75 3.75V10.25C10.75 10.4625 10.6785 10.6406 10.5356 10.7844C10.3927 10.9281 10.2156 11 10.0044 11C9.79313 11 9.61458 10.9281 9.46875 10.7844C9.32292 10.6406 9.25 10.4625 9.25 10.25ZM10 17C9.02778 17 8.11861 16.8159 7.2725 16.4478C6.4264 16.0796 5.68687 15.5791 5.0539 14.9461C4.42094 14.3131 3.92038 13.5736 3.55223 12.7275C3.18408 11.8814 3 10.9692 3 9.9909C3 9.0787 3.17361 8.20287 3.52083 7.3634C3.86806 6.52391 4.35409 5.77935 4.97894 5.12971C5.12835 4.97379 5.31853 4.89583 5.54946 4.89583C5.78038 4.89583 5.97222 4.97222 6.125 5.125C6.27778 5.27778 6.34722 5.44882 6.33333 5.63813C6.31944 5.82744 6.23611 5.99668 6.08333 6.14583C5.58488 6.66244 5.19637 7.25042 4.91783 7.90977C4.63928 8.56913 4.5 9.26587 4.5 10C4.5 11.5278 5.03645 12.8264 6.10935 13.8958C7.18227 14.9653 8.47761 15.5 9.99538 15.5C11.5262 15.5 12.8264 14.9653 13.8958 13.8958C14.9653 12.8264 15.5 11.5278 15.5 10C15.5 9.26389 15.3681 8.56597 15.1042 7.90625C14.8403 7.24653 14.4514 6.65972 13.9375 6.14583C13.7847 5.99306 13.7014 5.81944 13.6875 5.625C13.6736 5.43056 13.7364 5.26359 13.8759 5.1241C14.0281 4.97192 14.2197 4.89583 14.4506 4.89583C14.6816 4.89583 14.8718 4.97379 15.0213 5.12971C15.6599 5.77935 16.1493 6.52391 16.4896 7.3634C16.8299 8.20287 17 9.0787 17 9.9909C17 10.9692 16.8153 11.8814 16.4458 12.7275C16.0764 13.5736 15.5773 14.3131 14.9486 14.9461C14.3199 15.5791 13.581 16.0796 12.7319 16.4478C11.8829 16.8159 10.9722 17 10 17Z",
    fill: "#1A0063"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout2);
export default __webpack_public_path__ + "static/media/logout-2.0da90c5afb35fcbd5479bcc25dc1af03.svg";
export { ForwardRef as ReactComponent };